import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import "@fullcalendar/daygrid/main.css";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import AddIcon from "@mui/icons-material/Add";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { CircularProgress, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import AddWorkoutPopup from "src/pages/Calender/component/AddWorkoutPopup";
import EditWorkoutPopup from "src/pages/Calender/component/EditWorkoutPopup";
import {
  delete_program_workout_Api,
  update_program_workout_api,
  reorder_events_api,
  paste_multiple_workouts,
  delete_program_workout_Api_all,
} from "src/DAL/programmeWorkout/programmeWorkout";
import ConfirmationWithDescription from "../ModalPopover/ConfirmationWithDescription";
import PastedWorkouts from "./PastedWorkouts";
import EventCard from "./EventCard";
import CustomPopoverNew from "../CustomPopoverNew";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import ReviewsDate from "./ReviewsDate";
import { SHOW_PASTE_CONFIRMATION } from "src/utils/constant";
import { normalize_workout_date } from "src/utils/constant";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function GeneralCalendar({
  programWorkoutList,
  setCurrentDate,
  time_zone,
  currentDate,
  isLoading,
  reloadList,
  calendar_title,
  programme,
  isPasted,
  setIsPasted,
  difficultyLevel,
  setDifficultyLevel,
  calendarRef,
  goToToday,
  is_show_only,
  manualLoading,
  initialDate,
}) {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const classes = useStyles();
  const [drawerState, setDrawerState] = useState(false);
  const {
    setIsOpenNotePad,
    setSelectedNotepad,
    setPageTitle,
    setShowNavBackButton,
  } = useContentSetting();
  const [openDelete, setOpenDelete] = useState(false);
  const [openMultiDelete, setOpenMultiDelete] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [editItrationDrawerState, setEditItrationDrawerState] = useState();
  const [hoveredDate, setHoveredDate] = useState(null);
  const [selectedDate, setSelectDate] = useState("");
  const [dataDel, setDataDel] = useState();
  const [dataCopy, setDataCopy] = useState();
  const [pasteDate, setPasteDate] = useState();
  const [effectedMembers, setEffectedMembers] = useState(
    programme?.total_member_count,
  );
  const [editWorkputData, setEditWorkputData] = useState();
  const [openDragConfig, setOpenDragConfig] = useState(false);
  const [DragConfigDate, setDragConfigDate] = useState(false);
  const [DragConfigData, setDragConfigData] = useState(false);
  const [openCopyPasteConfig, setOpenCopyPasteConfig] = useState(false);
  const [selectedWorkouts, setSelectedWorkouts] = useState([]);
  const [pastedWorkouts, setPastedWorkouts] = useState([]);
  const [isPastedWorkouts, setIsPastedWorkouts] = useState(false);
  const [isReviewOpen, setIsReviewOpen] = useState(false);
  const [hoverdInfo, setHoverdInfo] = useState(null);
  const [isDragedloading, setIsDragedloading] = useState(false);
  const [globalOpen, setGlobalOpen] = useState(true);
  const globalOpenRef = React.useRef(true);
  React.useEffect(() => {
    globalOpenRef.current = globalOpen;
  }, [globalOpen]);

  const toolbarRowRef = useRef(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const handleCellHover = (info) => {
    setHoveredDate(info.date);
    setHoverdInfo(info);
  };

  const clearModalParams = () => {
    if (!is_show_only) {
      const params = new URLSearchParams(searchParams);
      params.delete("modal");
      params.delete("workoutId");
      // Keep the date param so calendar stays on the same month after modal closes
      setSearchParams(params, { replace: true });
    }
  };

  const handleCloseAddModal = () => {
    setDrawerState(false);
    clearModalParams();
  };

  const handleCloseEditModal = () => {
    setEditItrationDrawerState(false);
    clearModalParams();
  };

  const handleOpen = () => {
    let data = {
      title: programme?.title,
      _id: programme?._id,
      message:
        "This notepad is specific to this programme only and will not affect its members' notepad.",
    };
    setSelectedNotepad(data);
    setIsOpenNotePad(true);
  };

  const handleOpenMultiDelete = () => {
    setOpenMultiDelete(true);
  };

  const handleProgrammeMember = () => {
    setIsPastedWorkouts(true);
  };

  const isFirstEventOnDate = (test) => {
    let date = normalize_workout_date(test.workout_date);
    const sameDateEvents = events.filter((e) => e.date === date);
    return sameDateEvents[0]._id === test._id;
  };

  const isLastEventOnDate = (test) => {
    let date = normalize_workout_date(test.workout_date);
    const sameDateEvents = events.filter((e) => e.date === date);
    return sameDateEvents[sameDateEvents.length - 1]._id === test._id;
  };
  const handleScrollCalled = (data) => {
    const todayCell = document.querySelector(
      `.calendar-workout-card[id="${data}"]`,
    );
    if (todayCell)
      todayCell.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const handleOpenDrawer = (arg) => {
    setSelectDate(arg);
    setDrawerState(true);
    if (!is_show_only) {
      const params = new URLSearchParams(searchParams);
      params.set("modal", "add");
      params.set("date", moment(arg).format("YYYY-MM-DD"));
      setSearchParams(params, { replace: true });
    }
  };

  const isWorkoutSelected = (workout) =>
    selectedWorkouts.some((item) => item._id === workout?._id) ||
    (pastedWorkouts &&
      pastedWorkouts.some((item) => item._id === workout?._id));

  const handlePaste = async (arg) => {
    if (isPasted) return;

    setPasteDate(arg);
    if (SHOW_PASTE_CONFIRMATION) {
      setOpenCopyPasteConfig(true);
    } else {
      await handleCopyPaste(arg);
    }
  };

  const handleAgreeDelete = async (data) => {
    setDataDel(data);
    setEffectedMembers(programme?.members);
    setOpenDelete(true);
  };

  const handleCopyExercise = (data) => {
    setEditWorkputData();
    setPastedWorkouts();
    setSelectedWorkouts((prevSelected) => {
      const updatedSelected = prevSelected.some(
        (workout) => workout?._id === data._id,
      )
        ? prevSelected.filter((workout) => workout?._id !== data._id)
        : [...prevSelected, data];

      if (updatedSelected.length > 0) {
        setDataCopy(true);
      } else {
        setDataCopy(false);
      }

      return updatedSelected;
    });
  };

  const handleOpenEditIterationDrawer = () => {
    setEditItrationDrawerState(true);
  };

  const handleUpdateIteration = (data) => {
    setSelectDate(data?.workout_date);
    setEditWorkputData(data);
    handleOpenEditIterationDrawer();
    if (!is_show_only) {
      const params = new URLSearchParams(searchParams);
      params.set("modal", "edit");
      params.set("workoutId", data?._id);
      params.set("date", moment(data?.workout_date).format("YYYY-MM-DD"));
      setSearchParams(params, { replace: true });
    }
  };

  const closeDragConfig = async (value) => {
    setOpenDragConfig(false);
    getEventListing(programWorkoutList, time_zone);
  };

  const closeCopyPasteConfig = async (value) => {
    setPastedWorkouts([]);
    setSelectedWorkouts([]);
    setOpenCopyPasteConfig(false);
    setDataCopy(false);
    getEventListing(events, time_zone);
  };

  const handleCopyPaste = async (dateArg) => {
    setIsPasted(true);
    const workoutsIds = selectedWorkouts.map((workout) => workout?._id);

    const targetDate = dateArg || pasteDate;

    const formDataObject = {
      copiedWorkoutIds: workoutsIds,
      workout_copy_type: "unlimited",
      targetStartDate: moment(targetDate).format("YYYY-MM-DD"),
      target_program_id: programme?._id,
    };

    try {
      const result = await paste_multiple_workouts(formDataObject);
      if (result.code === 200) {
        setPastedWorkouts(result?.copiedWorkouts);
        setSelectedWorkouts([]);
        setDataCopy(false);
        reloadList(
          result?.copiedWorkouts[0]?._id,
          result.message,
          SHOW_PASTE_CONFIRMATION ? setOpenCopyPasteConfig : null,
          true,
        );
        setIsPasted(false);
        requestAnimationFrame(() => {
          window.scrollTo({ top: window.scrollY, behavior: "instant" });
        });
      } else {
        setSelectedWorkouts([]);
        enqueueSnackbar(result.message, { variant: "error" });
        setDataCopy(false);
        setIsPasted(false);
      }
    } catch (error) {
      setSelectedWorkouts([]);
      enqueueSnackbar("Failed to paste workouts", { variant: "error" });
      setDataCopy(false);
      setIsPasted(false);
    }
  };

  const handleDraged = async (value) => {
    setIsDragedloading(true);

    const formDataObject = {
      title: DragConfigData?.workout_title,
      description: DragConfigData?.description,
      exercises: DragConfigData?.workout_exercises,
      workout_type: "",
      library_type:
        DragConfigData?.practice_type === "workbook"
          ? DragConfigData?.library_type
          : "",
      questions: DragConfigData?.questions || [],
      status: true,
      workout_date: moment(DragConfigDate).format("YYYY-MM-DD"),
      video_url: DragConfigData?.video_url,
      video_thumbnail: DragConfigData?.video_thumbnail || {},
      comment: DragConfigData?.comment,
    };
    const formData = new FormData();

    formData.append("title", formDataObject.title);
    formData.append("description", formDataObject.description);
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    formData.append("workout_type", formDataObject.workout_type);

    formData.append("practice_type", DragConfigData?.practice_type);
    formData.append("target_day", DragConfigData?.target_day);
    formData.append("comment", DragConfigData?.comment);
    formData.append("meals", JSON.stringify(DragConfigData?.meals || []));
    formData.append("workout_note", DragConfigData?.workout_note);
    formData.append("status", formDataObject.status);
    formData.append(
      "workout_dates",
      JSON.stringify([formDataObject?.workout_date]),
    );
    formData.append("questions", JSON.stringify(formDataObject?.questions));
    formData.append("library_type", formDataObject?.library_type);
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );
    if (formDataObject.video_thumbnail) {
      formData.append(
        "duplicate_image_path",
        JSON.stringify(formDataObject.video_thumbnail),
      );
    }

    const result = await update_program_workout_api(
      formData,
      DragConfigData?.program_workout_slug,
    );
    if (result.code === 200) {
      setEditWorkputData(DragConfigData);
      reloadList(
        result?.program_workout?._id,
        result.message,
        setOpenDragConfig,
      );
      setTimeout(() => {
        setIsDragedloading(false);
      }, 2000);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsDragedloading(false);
      getEventListing(programWorkoutList, time_zone);
    }
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    const result = await delete_program_workout_Api(
      dataDel?.program_workout_slug,
    );
    if (result.code === 200) {
      setEditWorkputData();
      enqueueSnackbar(result.message, { variant: "success" });
      let updatedEvents = events.filter(
        (item) => item.program_workout_slug != dataDel.program_workout_slug,
      );
      setEvents(updatedEvents);
      const today = normalize_workout_date(dataDel?.workout_date);
      const todayCell = document.querySelector(`.fc-day[data-date="${today}"]`);
      if (todayCell) {
        todayCell.scrollIntoView({ behavior: "instant", block: "start" });
      }
      setPastedWorkouts([]);
      setSelectedWorkouts([]);
      setDataCopy(false);
      queryClient.invalidateQueries({ queryKey: ["programWorkouts"] });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleDeleteMultipul = async () => {
    setOpenMultiDelete(false);
    const postData = {
      program_workout_slugs: selectedWorkouts.map(
        (workout) => workout?.program_workout_slug,
      ),
    };
    const result = await delete_program_workout_Api_all(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      let updatedEvents = events.filter(
        (item) =>
          !postData.program_workout_slugs.includes(item.program_workout_slug),
      );
      setEvents(updatedEvents);
      setEditWorkputData();
      setPastedWorkouts([]);
      setSelectedWorkouts([]);
      setDataCopy(false);
      queryClient.invalidateQueries({ queryKey: ["programWorkouts"] });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleReorder = async (newevents) => {
    const ids = newevents.map((event) => event._id);
    let postData = {
      workoutIds: ids,
    };
    const result = await reorder_events_api(postData);
    if (result.code !== 200) {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleExpandAll = () => {
    setGlobalOpen(true);
    globalOpenRef.current = true;
    setEvents((prev) => prev.map((e) => ({ ...e, open: true })));
  };

  const handleCollapseAll = () => {
    setGlobalOpen(false);
    globalOpenRef.current = false;
    setEvents((prev) => prev.map((e) => ({ ...e, open: false })));
  };

  const renderEventContent = useCallback(
    (eventInfo) => {
      return (
        <EventCard
          workout={eventInfo.event}
          handleReorder={handleReorder}
          isWorkoutSelected={isWorkoutSelected}
          editWorkputData={editWorkputData}
          isFirstEventOnDate={isFirstEventOnDate}
          isLastEventOnDate={isLastEventOnDate}
          handleScrollCalled={handleScrollCalled}
          handleCopyExercise={handleCopyExercise}
          handleAgreeDelete={handleAgreeDelete}
          setEditWorkputData={setEditWorkputData}
          setEvents={setEvents}
          events={events}
          handleUpdateIteration={
            is_show_only ? () => {} : handleUpdateIteration
          }
          is_show_only={is_show_only}
        />
      );
    },
    [events, editWorkputData, selectedWorkouts, pastedWorkouts, is_show_only],
  );

  const getEventListing = async (workout) => {
    let all_events = [];
    if (workout?.length > 0) {
      all_events = workout?.map((workout, i) => {
        return {
          ...workout,
          title: workout?.title,
          color: workout?.program_info?.color,
          workout_color: workout?.program_info?.color,
          workout_title: workout?.title,
          workout_exercises: workout?.exercises,
          workout_program: workout?.program_info,
          status: workout?.status,
          is_deleteAble: workout?.workout_loggers?.length > 0 ? false : true,
          date: normalize_workout_date(workout?.workout_date),
          index: i,
          open: globalOpenRef.current,
          editable: workout?.workout_loggers?.length > 0 ? false : true,
          order: i,
        };
      });
    }

    setEvents(all_events);
  };

  const getCenteredText = () => {
    let text = moment(new Date()).format("MMM YYYY");
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentMonth = calendarApi.getDate().getMonth();
      const currentYear = calendarApi.getDate().getFullYear();

      text = moment().month(currentMonth).format("MMM") + " " + currentYear;
    }
    return text;
  };

  const hanldeChangeDates = (value) => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;

    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();

      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
    let new_object = {};
    if (value == "next") {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    } else {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    }
    setCurrentDate(new_object);
  };

  const handleChangeNextPrev = (value) => {
    let classToClick = "fc-next-button";
    if (value == "prev") {
      classToClick = "fc-prev-button";
    }
    let click_element = document.getElementsByClassName(classToClick)[0];
    click_element.click();
    hanldeChangeDates(value);
    // Update date param to reflect new month, remove modal params
    if (!is_show_only && calendarRef?.current) {
      const calendarApi = calendarRef.current.getApi();
      const newDate = moment(calendarApi.getDate()).format("YYYY-MM-DD");
      const params = new URLSearchParams(searchParams);
      params.set("date", newDate);
      params.delete("modal");
      params.delete("workoutId");
      setSearchParams(params, { replace: true });
    }
  };

  const handleClickDate = (workout) => {
    setCurrentDate({
      start_date: workout?.dateStr,
      end_date: workout?.dateStr,
    });
  };

  const handleEventDrop = (info) => {
    const { event } = info;
    const eventData = event.extendedProps;
    setOpenDragConfig(true);
    setDragConfigDate(event.start);
    setDragConfigData(eventData);
  };

  const renderDayCell = (arg) => {
    const isHovered = is_show_only
      ? null
      : hoveredDate && arg.date.getTime() === hoveredDate.getTime();

    return (
      <div
        style={{
          position: "relative",
          height: "100%",
          marginTop: -10,
        }}
      >
        <span>{arg?.dayNumberText}</span>{" "}
        <span
          className="day-cell-name"
          style={{
            opacity: 0.5,
            fontSize: 10,
          }}
        >
          {moment(arg?.date).format("ddd")}
        </span>
        {isHovered && (
          <div className="cell-icon-workout d-flex text-end w-100">
            {dataCopy && (
              <Tooltip touch="on" placement="bottom" title={"Paste"}>
                <div
                  className="paste-icon-workout-general me-1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "19px",
                    minHeight: "19px",
                  }}
                >
                  <AssignmentTurnedInIcon
                    sx={{
                      cursor: "pointer",
                      height: 15,
                      width: 15,
                    }}
                    onClick={() => handlePaste(arg?.date)}
                  />
                </div>
              </Tooltip>
            )}

            <AddIcon
              className="add-icon-workout-general "
              onClick={() => handleOpenDrawer(arg?.date)}
              sx={{
                cursor: "pointer",
              }}
            />
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;

    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();

      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
  }, [calendarRef]);

  function getNewDates(refDate, inputDate) {
    const dateDifferences = [];
    const referenceDates = refDate
      .map((date) => new Date(date.split("/").reverse().join("-")))
      .sort((a, b) => a - b);

    for (let i = 1; i < referenceDates.length; i++) {
      const diffInDays =
        (referenceDates[i] - referenceDates[i - 1]) / (1000 * 60 * 60 * 24);
      dateDifferences.push(diffInDays);
    }

    const newDates = [new Date(inputDate.split("/").reverse().join("-"))];

    for (let diff of dateDifferences) {
      const nextDate = new Date(newDates[newDates.length - 1]);
      nextDate.setDate(nextDate.getDate() + diff);
      newDates.push(nextDate);
    }

    newDates.sort((a, b) => a - b);

    return newDates.map((date) =>
      date.toLocaleDateString("en-GB").split("/").join("/"),
    );
  }

  const eventOrderFunction = (a, b) => {
    return a.order - b.order;
  };

  useEffect(() => {
    if (!hoverdInfo) return;
    const cellDate = moment(hoverdInfo?.date).format("DD/MM/YYYY");
    const dates = selectedWorkouts.map((workout) => {
      return moment.utc(workout?.workout_date).format("DD/MM/YYYY");
    });

    let newDates = [];
    if (dates.length > 0 && cellDate) {
      newDates = getNewDates(dates, cellDate);
    }
    document.querySelectorAll(".fc-daygrid-day").forEach((cell) => {
      cell.classList.remove("highlighted-hover");
    });
    if (newDates.length > 0) {
      document.querySelectorAll(".fc-daygrid-day").forEach((cell) => {
        const cellDate = moment(cell.getAttribute("data-date")).format(
          "DD/MM/YYYY",
        );

        if (newDates.includes(cellDate)) {
          cell.classList.add("highlighted-hover");
        }
      });
    }
  }, [hoverdInfo, selectedWorkouts]);

  useEffect(() => {
    getEventListing(programWorkoutList, time_zone);
  }, [programWorkoutList]);

  useEffect(() => {
    setEffectedMembers(programme?.members);
  }, [programme?.members]);

  useEffect(() => {
    if (calendar_title) {
      setPageTitle(calendar_title);
    }
    setShowNavBackButton(true);
    return () => {
      setPageTitle("");
      setShowNavBackButton(false);
    };
  }, [calendar_title]);

  useEffect(() => {
    if (is_show_only) return;

    const modalType = searchParams.get("modal");
    const dateParam = searchParams.get("date");

    if (modalType !== "add" || !dateParam) return;

    // Case: invalid date → remove all params including date
    if (!moment(dateParam, "YYYY-MM-DD", true).isValid()) {
      const params = new URLSearchParams(searchParams);
      params.delete("modal");
      params.delete("workoutId");
      params.delete("date");
      setSearchParams(params, { replace: true });
      return;
    }

    // Valid date — check if it's in the currently visible month
    if (calendarRef?.current) {
      const calendarApi = calendarRef.current.getApi();
      const targetDate = moment(dateParam).toDate();
      const currentViewStart = calendarApi.view.activeStart;
      const currentViewEnd = calendarApi.view.activeEnd;
      const isAlreadyVisible =
        targetDate >= currentViewStart && targetDate < currentViewEnd;
      if (!isAlreadyVisible) {
        // Navigate to target month first, modal will open on next render
        calendarApi.gotoDate(targetDate);
        setCurrentDate({
          start_date: calendarApi.view.activeStart,
          end_date: calendarApi.view.activeEnd,
        });
        return;
      }
    }
    const date = moment(dateParam).toDate();
    setSelectDate(date);
    setDrawerState(true);
  }, [searchParams, calendarRef?.current, is_show_only]);

  useEffect(() => {
    if (is_show_only || !programWorkoutList || programWorkoutList.length === 0)
      return;

    const modalType = searchParams.get("modal");
    const dateParam = searchParams.get("date");
    const workoutId = searchParams.get("workoutId");

    if (modalType !== "edit" || !workoutId) return;

    const workout = programWorkoutList.find((w) => w._id === workoutId);
    if (workout) {
      // Workout found — open modal
      setSelectDate(workout?.workout_date);
      setEditWorkputData(workout);
      setEditItrationDrawerState(true);
    } else if (dateParam && moment(dateParam, "YYYY-MM-DD", true).isValid()) {
      // Valid date but workout not in current month's data
      // Navigate calendar to that month so parent fetches it
      if (calendarRef?.current) {
        const calendarApi = calendarRef.current.getApi();
        const targetDate = moment(dateParam).toDate();
        const currentViewStart = calendarApi.view.activeStart;
        const currentViewEnd = calendarApi.view.activeEnd;
        const isAlreadyVisible =
          targetDate >= currentViewStart && targetDate < currentViewEnd;
        if (!isAlreadyVisible) {
          // Navigate to target month to trigger data fetch
          calendarApi.gotoDate(targetDate);
          setCurrentDate({
            start_date: calendarApi.view.activeStart,
            end_date: calendarApi.view.activeEnd,
          });
        } else {
          // Already on correct month but workout not found → deleted workout
          // Stay on this month, just clear modal params
          clearModalParams();
        }
      } else {
        clearModalParams();
      }
    } else {
      // Invalid date or no date → remove all params including date
      const params = new URLSearchParams(searchParams);
      params.delete("modal");
      params.delete("workoutId");
      params.delete("date");
      setSearchParams(params, { replace: true });
    }
  }, [searchParams, programWorkoutList, is_show_only]);

  useEffect(() => {
    let isHeaderFixed = false;
    let headerPlaceholder = null;
    const originalCellTexts = new Map();

    const getNavbarHeight = () => {
      const navbar =
        document.querySelector(".mini-drawer-menu-title") ||
        document.querySelector("header") ||
        document.querySelector("nav");
      return navbar ? navbar.getBoundingClientRect().height : 64;
    };

    const getColHeader = () => document.querySelector(".fc .fc-col-header");

    const getTableWidth = () => {
      const fcTable = document.querySelector(".fc .fc-scrollgrid");
      return fcTable ? fcTable.getBoundingClientRect().width : 0;
    };

    // Inject date numbers into header cells from the current top week row
    const injectDatesIntoHeader = (weekRow) => {
      const fcColHeader = getColHeader();
      if (!fcColHeader || !weekRow) return;

      const headerCells = fcColHeader.querySelectorAll(
        ".fc-col-header-cell-cushion",
      );
      const dayCells = weekRow.querySelectorAll(".fc-daygrid-day");
      if (!headerCells.length || !dayCells.length) return;

      dayCells.forEach((cell, i) => {
        const cushion = headerCells[i];
        if (!cushion) return;

        const dayNumberEl = cell.querySelector(".fc-daygrid-day-number");
        const dateText = dayNumberEl ? dayNumberEl.textContent.trim() : "";

        // Save original HTML once
        if (!originalCellTexts.has(cushion)) {
          originalCellTexts.set(cushion, cushion.innerHTML);
        }

        // Set: date number (bold, left) + day name (center) — same row
        cushion.style.display = "flex";
        cushion.style.flexDirection = "row";
        cushion.style.alignItems = "center";
        cushion.style.padding = "3px 6px";
        cushion.style.width = "100%";

        const existing = cushion.querySelector(".fc-sticky-date-num");
        if (existing) {
          existing.textContent = dateText;
        } else {
          cushion.innerHTML = `
            <span class="fc-sticky-date-num" style="font-size:13px;font-weight:800;line-height:1.2;">${dateText}</span>
          `;
        }
      });
    };

    const restoreHeaderCells = () => {
      originalCellTexts.forEach((html, cushion) => {
        cushion.innerHTML = html;
        cushion.style.display = "";
        cushion.style.flexDirection = "";
        cushion.style.alignItems = "";
        cushion.style.padding = "";
        cushion.style.width = "";
      });
      originalCellTexts.clear();
    };

    // ---------- Day-name header (Sun Mon Tue…) ----------
    const applyHeaderFixed = () => {
      if (isHeaderFixed) return;
      const fcColHeader = getColHeader();
      if (!fcColHeader) return;

      const navbarH = getNavbarHeight();
      const headerH = fcColHeader.getBoundingClientRect().height;
      const tableW = getTableWidth();

      headerPlaceholder = document.createElement("tr");
      headerPlaceholder.style.height = `${headerH}px`;
      headerPlaceholder.style.display = "table-row";
      if (fcColHeader.parentNode) {
        fcColHeader.parentNode.insertBefore(
          headerPlaceholder,
          fcColHeader.nextSibling,
        );
      }

      fcColHeader.style.position = "fixed";
      fcColHeader.style.top = `${navbarH}px`;
      fcColHeader.style.width = `${tableW}px`;
      fcColHeader.style.left = "307px";
      fcColHeader.style.zIndex = "11";
      fcColHeader.style.backgroundColor =
        "var(--background-primary-color, #1a1a1a)";

      isHeaderFixed = true;
    };

    const removeHeaderFixed = () => {
      if (!isHeaderFixed) return;
      const fcColHeader = getColHeader();
      if (fcColHeader) {
        fcColHeader.style.position = "";
        fcColHeader.style.top = "";
        fcColHeader.style.width = "";
        fcColHeader.style.zIndex = "";
        fcColHeader.style.backgroundColor = "";
      }
      if (headerPlaceholder && headerPlaceholder.parentNode) {
        headerPlaceholder.parentNode.removeChild(headerPlaceholder);
      }
      headerPlaceholder = null;
      isHeaderFixed = false;
      restoreHeaderCells();
    };

    // ---------- Main scroll handler ----------
    const handleScroll = () => {
      const toolbarEl = toolbarRowRef.current;
      if (!toolbarEl) return;

      const navbarH = getNavbarHeight();
      const toolbarBottomFromTop = toolbarEl.getBoundingClientRect().bottom;

      if (toolbarBottomFromTop <= navbarH - 20) {
        applyHeaderFixed();

        // Find which week row is currently at the top
        const weekRows = document.querySelectorAll(
          ".fc .fc-daygrid-body > table > tbody > tr",
        );
        const fcColHeader = getColHeader();
        const headerBottom = fcColHeader
          ? fcColHeader.getBoundingClientRect().bottom
          : navbarH + 40;

        let currentWeekRow = null;
        weekRows.forEach((row) => {
          const rowRect = row.getBoundingClientRect();
          if (rowRect.top <= headerBottom + 2) {
            currentWeekRow = row;
          }
        });

        if (currentWeekRow) {
          injectDatesIntoHeader(currentWeekRow);
        }

        // Sync day-name header width
        if (fcColHeader) {
          fcColHeader.style.width = `${getTableWidth()}px`;
        }
      } else {
        removeHeaderFixed();
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Keep widths in sync on resize
    const resizeObserver = new ResizeObserver(() => {
      const fcColHeader = getColHeader();
      if (fcColHeader && fcColHeader.style.position === "fixed") {
        fcColHeader.style.width = `${getTableWidth()}px`;
      }
    });
    if (toolbarRowRef.current) {
      resizeObserver.observe(toolbarRowRef.current);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
      removeHeaderFixed();
    };
  }, [
    is_show_only,
    selectedWorkouts.length,
    events.length,
    programme?.difficulty_level,
  ]);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div
      className="container-fluid full-calendar-toolbar"
      style={{ position: "relative" }}
    >
      {isPasted && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" />
        </div>
      )}
      <div
        className={`row ${is_show_only ? "mt-4" : "mt-1"}`}
        ref={toolbarRowRef}
      >
        {/* LEFT TOOLBAR */}
        {!is_show_only && (
          <div className="col-12 mb-2">
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              justifyContent="space-between"
              alignItems={{ xs: "stretch", sm: "center" }}
              flexWrap="wrap"
            >
              {/* Left Side — placeholder kept for layout balance */}
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap />

              {/* Right Side */}
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                useFlexGap
                justifyContent={{ xs: "flex-start", sm: "flex-end" }}
              >
                <Tooltip title="Open Notepad" arrow>
                  <IconButton
                    size="small"
                    onClick={handleOpen}
                    sx={{
                      bgcolor: "primary.main",
                      color: "#fff",
                      borderRadius: "8px",
                      px: 1.2,
                      py: 0.6,
                      "&:hover": { bgcolor: "primary.dark" },
                    }}
                  >
                    <NoteAltOutlinedIcon fontSize="small" />
                    <span
                      style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}
                    >
                      Notepad
                    </span>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Set Review Date" arrow>
                  <IconButton
                    size="small"
                    onClick={() => setIsReviewOpen(true)}
                    sx={{
                      bgcolor: "primary.main",
                      color: "#fff",
                      borderRadius: "8px",
                      px: 1.2,
                      py: 0.6,
                      "&:hover": { bgcolor: "primary.dark" },
                    }}
                  >
                    <EventAvailableOutlinedIcon fontSize="small" />
                    <span
                      style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}
                    >
                      Review Date
                    </span>
                  </IconButton>
                </Tooltip>

                {programme?.difficulty_level && (
                  <FormControl
                    sx={{
                      minWidth: 150,
                      "& .MuiOutlinedInput-root": {
                        height: "30px",
                        fontSize: 12,
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: 12,
                        top: "-3px",
                        "&.MuiInputLabel-shrink": { top: 0 },
                      },
                      flexShrink: 0,
                    }}
                    size="small"
                  >
                    <InputLabel id="gc-difficulty-label">
                      Difficulty Levels
                    </InputLabel>
                    <Select
                      labelId="gc-difficulty-label"
                      id="gc-difficulty-select"
                      multiple
                      name="difficulty_levels"
                      value={difficultyLevel}
                      label="Difficulty Levels"
                      onChange={(e) => setDifficultyLevel(e.target.value)}
                    >
                      <MenuItem value="novice">Novice</MenuItem>
                      <MenuItem value="intermediate">Intermediate</MenuItem>
                      <MenuItem value="advanced">Advanced</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Stack>
            </Stack>
          </div>
        )}

        {/* NAV LEFT */}
        <div className="col-12 col-sm-4 mt-2 text-start">
          <div className="d-flex align-items-center">
            <div className="btn-group toollbar-group-buttons group-buttons-font-size-on-sm">
              <button
                className="small-contained-button"
                onClick={() => handleChangeNextPrev("prev")}
              >
                <ArrowBackIosIcon />
              </button>
              <button
                className="small-contained-button"
                onClick={() => handleChangeNextPrev("next")}
              >
                <ArrowForwardIosIcon />
              </button>
            </div>
            {manualLoading && (
              <CircularProgress
                size={20}
                style={{ marginLeft: "8px", verticalAlign: "middle" }}
              />
            )}
          </div>
        </div>

        {/* CENTER TITLE */}
        <div className="col-12 col-sm-4 mt-2 text-sm-center text-start">
          <h3 className="font-size-on-sm mb-0">{getCenteredText()}</h3>
        </div>

        {/* RIGHT ACTIONS */}
        {!is_show_only && (
          <div className="col-12 col-sm-4 mt-2 d-flex flex-wrap justify-content-sm-end justify-content-start align-items-center gap-2">
            {events.length > 0 && (
              <>
                <Button
                  size="small"
                  onClick={handleExpandAll}
                  startIcon={<KeyboardArrowDownIcon />}
                  sx={{
                    bgcolor: "grey.700",
                    color: "#fff",
                    borderRadius: "8px",
                    px: 1,
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    py: 0.5,
                    "&:hover": { bgcolor: "grey.900" },
                  }}
                >
                  Expand All
                </Button>

                <Button
                  size="small"
                  onClick={handleCollapseAll}
                  startIcon={<KeyboardArrowUpIcon />}
                  sx={{
                    bgcolor: "grey.700",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    px: 1,
                    py: 0.5,
                    "&:hover": { bgcolor: "grey.900" },
                  }}
                >
                  Collapse All
                </Button>
              </>
            )}

            <Button variant="outlined" size="small" onClick={goToToday}>
              Today
            </Button>
          </div>
        )}
      </div>
      <div className="row">
        <div
          className="full-calendar full-calendar-new-flow mt-3"
          onMouseLeave={() => setHoveredDate(null)}
        >
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "today prev,next",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            className="fc-day-sun fc-toolbar-chunk fc eventimage fc-col-header-cell-cushion fc-today-button fc-right fc-prev-button fc-right fc-next-button fc-dayGridMonth-button fc-timeGridWeek-button fc-timeGridDay-button fc-daygrid-day-number fc-daygrid-day-top"
            eventContent={renderEventContent}
            events={events}
            initialView="dayGridMonth"
            initialDate={initialDate || undefined}
            dayCellContent={renderDayCell}
            eventDrop={(arg) => {
              if (is_show_only) {
                arg.revert();
                return;
              }
              handleEventDrop(arg);
            }}
            editable={!is_show_only}
            height="auto"
            stickyHeaderDates={false}
            selectable={!is_show_only}
            selectMirror={!is_show_only}
            eventOrder={eventOrderFunction}
            weekends={true}
            fixedWeekCount={false}
            moreLinkContent={function (args) {
              return "+" + args.num;
            }}
            moreLinkClick={function (args) {
              if (!is_show_only) {
                handleClickDate(args);
              }
            }}
            dayCellDidMount={(arg) => {
              const cell = arg.el;
              cell.addEventListener("mouseover", () => {
                if (!is_show_only) {
                  handleCellHover(arg);
                }
              });
            }}
          />
        </div>
      </div>
      {/* Floating action buttons — shown when workouts are selected */}
      {!is_show_only && selectedWorkouts.length > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 99999,
            display: "flex",
            flexDirection: "row",
            gap: 10,
            alignItems: "center",
          }}
        >
          <Tooltip title="Delete selected workouts" arrow placement="top">
            <IconButton
              size="small"
              onClick={handleOpenMultiDelete}
              sx={{
                bgcolor: "error.main",
                color: "#fff",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                boxShadow: 4,
                fontSize: 12,
                "&:hover": { bgcolor: "error.dark" },
              }}
            >
              <DeleteIcon fontSize="small" />
              <span style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}>
                Delete ({selectedWorkouts.length})
              </span>
            </IconButton>
          </Tooltip>

          <Tooltip title="Copy to Programme / Member" arrow placement="top">
            <IconButton
              size="small"
              onClick={handleProgrammeMember}
              sx={{
                bgcolor: "primary.main",
                color: "#fff",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                boxShadow: 4,
                "&:hover": { bgcolor: "primary.dark" },
              }}
            >
              <ContentPasteIcon fontSize="small" />
              <span style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}>
                Copy
              </span>
            </IconButton>
          </Tooltip>

          <Tooltip title="Discard selection" arrow placement="top">
            <IconButton
              size="small"
              onClick={() => {
                setSelectedWorkouts([]);
                setDataCopy(false);
              }}
              sx={{
                bgcolor: "grey.600",
                color: "#fff",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                boxShadow: 4,
                "&:hover": { bgcolor: "grey.800" },
              }}
            >
              <CloseIcon fontSize="small" />
              <span style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}>
                Discard
              </span>
            </IconButton>
          </Tooltip>
        </div>
      )}

      {!is_show_only && (
        <>
          <ConfirmationWithDescription
            open={openDelete}
            setOpen={setOpenDelete}
            title={"Are you sure you want to Delete?"}
            descriotion={`If you take action it will delete from ${effectedMembers} users.`}
            handleAgree={handleDelete}
          />
          <ConfirmationWithDescription
            open={openMultiDelete}
            setOpen={setOpenMultiDelete}
            title={"Are you sure you want to Delete?"}
            descriotion=""
            handleAgree={handleDeleteMultipul}
          />
          <ConfirmationWithDescription
            open={openDragConfig}
            setOpen={closeDragConfig}
            title={"Do you want to take this action?"}
            descriotion={`It will impact ${effectedMembers} users, who has access to this program.`}
            handleAgree={handleDraged}
            isLoading={isDragedloading}
          />
          <ConfirmationWithDescription
            open={openCopyPasteConfig}
            setOpen={closeCopyPasteConfig}
            title={"Do you want to paste it here?"}
            descriotion={`It will impact ${effectedMembers} users, who has access to this program.`}
            handleAgree={handleCopyPaste}
            isLoading={isPasted}
          />
          <AddWorkoutPopup
            open={drawerState}
            setOpen={handleCloseAddModal}
            date={selectedDate}
            programme={programme}
            reloadList={reloadList}
            setEditWorkputData={setEditWorkputData}
            setEvents={setEvents}
            events={events}
          />
          <EditWorkoutPopup
            open={editItrationDrawerState}
            setOpen={handleCloseEditModal}
            date={selectedDate}
            programme={programme}
            data={editWorkputData}
            reloadList={reloadList}
            setEvents={setEvents}
            events={events}
          />
          <CustomPopoverNew
            isOpenPop={isPastedWorkouts}
            isClosePop={setIsPastedWorkouts}
            title="Add To Programme/Member"
            componentToPassDown={
              <div className="px-4 pb-3">
                <PastedWorkouts
                  selectedWorkouts={selectedWorkouts}
                  setSelectedWorkouts={setSelectedWorkouts}
                  setDataCopy={setDataCopy}
                  setIsPastedWorkouts={setIsPastedWorkouts}
                />
              </div>
            }
          />
          {isReviewOpen && (
            <CustomPopoverNew
              width="550px"
              isOpenPop={isReviewOpen}
              isClosePop={setIsReviewOpen}
              title="Review Date"
              componentToPassDown={
                <div className="px-4 pb-3">
                  <ReviewsDate
                    programme={programme}
                    isClosePop={setIsReviewOpen}
                    view="program"
                  />
                </div>
              }
            />
          )}
        </>
      )}
    </div>
  );
}

export default GeneralCalendar;
